<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ isEditing ? 'Editar Categoria' : 'Nova Categoria' }}
        </span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="saveCategory">
          <v-text-field
            v-model="categoryForm.name"
            label="Nome da Categoria"
            :rules="nameRules"
            required
            outlined
            autofocus
          />

          <div class="mb-4">
            <v-subheader class="px-0">Ícone da Categoria</v-subheader>
            <div class="d-flex align-center gap-3">
              <v-avatar
                size="60"
                :color="platform?.colors?.light?.primary || '#6366f1'"
                class="white--text"
              >
                <v-img
                  v-if="categoryForm.icon"
                  :src="categoryForm.icon"
                  :alt="categoryForm.name"
                  contain
                />
                <span v-else class="text-h6">
                  {{ categoryForm.name ? categoryForm.name.charAt(0).toUpperCase() : '?' }}
                </span>
              </v-avatar>

              <div>
                <v-btn
                  small
                  outlined
                  @click="$refs.fileInput.click()"
                  :loading="uploadingIcon"
                >
                  <v-icon left small>mdi-upload</v-icon>
                  Escolher Ícone
                </v-btn>
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="uploadIcon"
                />
                <div class="text-caption text--secondary mt-1">
                  PNG recomendado, tamanho máximo 2MB
                </div>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closeDialog"
          :disabled="saving"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          @click="saveCategory"
          :loading="saving"
          :disabled="!valid"
        >
          {{ isEditing ? 'Atualizar' : 'Criar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "CategoryCreateEditDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    platform: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: false,
      saving: false,
      uploadingIcon: false,
      categoryForm: {
        name: "",
        icon: null
      },
      nameRules: [
        v => !!v || "Nome é obrigatório",
        v => (v && v.length >= 2) || "Nome deve ter pelo menos 2 caracteres"
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    isEditing() {
      return !!this.category;
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.category) {
        this.categoryForm = { 
          name: this.category.name, 
          icon: this.category.icon 
        };
      } else if (newVal) {
        this.categoryForm = { name: "", icon: null };
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.categoryForm = { name: "", icon: null };
    },

    async saveCategory() {
      if (!this.$refs.form?.validate()) return;
      if (!this.categoryForm.name?.trim()) return;

      try {
        this.saving = true;
        
        if (this.isEditing) {
          await platformService.updateCategory(
            this.platform.id,
            this.category.id,
            this.categoryForm
          );
        } else {
          await platformService.createCategory(this.platform.id, this.categoryForm);
        }

        this.closeDialog();
        this.$emit('saved');
        
      } catch (error) {
        console.error("Erro ao salvar categoria:", error);
      } finally {
        this.saving = false;
      }
    },

    async uploadIcon(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 2 * 1024 * 1024) return;

      try {
        this.uploadingIcon = true;
        const categoryId = this.isEditing ? this.category.id : "temp";
        
        const response = await platformService.uploadCategoryIcon(
          this.platform.id,
          categoryId,
          file
        );
        
        this.categoryForm.icon = response.iconUrl;
        
        if (this.isEditing) {
          this.$emit('saved');
        }
      } catch (error) {
        console.error("Erro ao fazer upload do ícone:", error);
      } finally {
        this.uploadingIcon = false;
      }

      event.target.value = "";
    }
  }
};
</script>

<style scoped>
.gap-3 {
  gap: 12px;
}
</style> 